import React from 'react';
import { motion } from 'framer-motion';
import { Check, Compass, Target, BoxIcon } from 'lucide-react';
const capabilities = ['Digital strategy & UX direction', 'Web design & design systems', 'E-commerce experiences', 'WordPress, Drupal & Shopify builds', 'Custom platforms & integrations', 'Performance-focused optimisation'];
const principles = [{
  icon: Compass,
  title: 'Start with clarity',
  detail: 'We align the brief, audience and commercial objective before making a single screen.'
}, {
  icon: BoxIcon,
  title: 'Design for the whole system',
  detail: 'Every interaction is considered across content, journeys, technology and future growth.'
}, {
  icon: Target,
  title: 'Build for the outcome',
  detail: 'The work is measured by what it enables: stronger brands, better journeys and useful results.'
}];
export function AboutSection() {
  return <section id="studio" className="relative overflow-hidden bg-dark-lighter py-24" data-id="element-13">
      <div className="mx-auto max-w-[1320px] px-4" data-id="element-14">
        <div className="grid items-start gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          x: -32
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.55
        }} data-id="element-16">
            <p className="mb-3 font-inter text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-17">
              The Byteweb approach
            </p>
            <h2 className="font-syne text-4xl font-bold leading-tight text-white md:text-5xl" data-id="element-18">
              Strategy, design and technology in one focused studio.
            </h2>
            <p className="mt-7 max-w-xl font-inter text-lg leading-relaxed text-white/65" data-id="element-19">
              We bring the practical thinking of an embedded digital team to
              every engagement. From a new e-commerce platform to a sharper
              brand experience, Byteweb turns complex goals into clear,
              considered digital products.
            </p>
            <p className="mt-5 max-w-xl font-inter leading-relaxed text-white/55" data-id="element-20">
              Our process is collaborative, direct and shaped around the people
              who will use—and run—what we create. The result is work that looks
              intentional, works hard and stays useful.
            </p>

            <div className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-21">
              {capabilities.map(capability => <div key={capability} className="flex items-start gap-3 rounded-xl border border-white/10 bg-dark p-4" data-id="element-22">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-23" />
                  <span className="font-inter text-sm leading-relaxed text-white/75" data-id="element-24">
                    {capability}
                  </span>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 32
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.55,
          delay: 0.1
        }} className="rounded-2xl border border-white/10 bg-dark p-6 shadow-2xl sm:p-9" data-id="element-25">
            <div className="mb-10 flex items-center justify-between border-b border-white/10 pb-6" data-id="element-26">
              <p className="font-syne text-xl font-bold text-white" data-id="element-27">
                How we work
              </p>
              <span className="font-inter text-xs font-bold uppercase tracking-[0.18em] text-gold" data-id="element-28">
                01—03
              </span>
            </div>

            <div className="space-y-8" data-id="element-29">
              {principles.map((principle, index) => {
              const Icon = principle.icon;
              return <div key={principle.title} className="flex gap-5" data-id="element-30">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-gold/25 bg-gold/10 text-gold" data-id="element-31">
                      <Icon size={20} data-id="element-32" />
                    </div>
                    <div data-id="element-33">
                      <div className="flex items-baseline gap-3" data-id="element-34">
                        <span className="font-inter text-xs font-bold text-gold" data-id="element-35">
                          0{index + 1}
                        </span>
                        <h3 className="font-syne text-xl font-bold text-white" data-id="element-36">
                          {principle.title}
                        </h3>
                      </div>
                      <p className="mt-2 font-inter text-sm leading-relaxed text-white/55" data-id="element-37">
                        {principle.detail}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            <div className="mt-10 border-t border-white/10 pt-6" data-id="element-38">
              <p className="font-inter text-sm leading-relaxed text-white/60" data-id="element-39">
                Based in Cape Town, partnering with teams wherever the work
                takes us.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}